import { reactive } from 'sitekit-extensions'
import on from '../util/elements/on'
import tooltipper from '../util/elements/tooltipper'
import { breakpoints } from '../vars'

const NEVER = /NEVER/

export default function(Site, $) {
  /* 
  Reference data properties by {{name}} and they will be replaced
  */
  const tooltipTemplate = `
    <h4>{{title}}</h4>
    <div class='tip-info'>
      <div class='info-bg' style='background-color: {{bgcol}};'></div>
      <p class='start-date-allday-{{allDay}}'>{{startDate}}<span class='all-day-{{allDay}}'></span><span class='start-time'>, {{startTime}}</span></p>
      <p class='end-date-allday-{{allDay}}'>{{endDate}}, {{endTime}}</p>
    </div>
    `

  Site.widget('calendar', {
    use: [reactive()],
    async _create() {
      this.state = {
        years: [],
        cats: [],
        ready: false,
        yearsForm: {},
        catsForm: {},
        staffForm: {}
      }

      this.calEl = this.element.find('.calendar')
      this.yearsForm = this.element.find('form#year-filter')
      this.catsForm = this.element.find('form#cat-filter')
      this.staffForm = this.element.find('form#staff-filter')
      this.forms = ['yearsForm', 'catsForm', 'staffForm']

      this.resize()

      // Give the page some time to become responsive before we bombard it
      await wait(600)

      /* 
      Only require calendar stuff when it is first used */
      const [{ Calendar }, moment] = await Promise.all([
        import('fullcalendar'),
        import('moment').then(x => x.default),
        // import('fullcalendar/dist/fullcalendar.css')
      ])

      let defaultView = 'month'
      if (document.documentElement.clientWidth < breakpoints.md.min) {
        defaultView = 'listWeek'
      }

      this.calendar = new Calendar(this.calEl, {
        customButtons: {
          print: {
            text: 'Print',
            click: () => {
              window.print();
            }
          }
        },
        header: {
          left: 'prev,month,agendaWeek,listWeek',
          center: 'title',
          right: 'next, print'
        },
        defaultView: defaultView,
        views: {
          agenda: { // name of view
            columnHeaderFormat: 'ddd DD/MM'
            // other view-specific options here
          }
        },
        validRange: function(nowDate) {
          return {
            start: nowDate.year() + '-01-01',
            end: (nowDate.year() + 1)+ '-12-31' 
          };
        },
        eventOrder: 'title',

        eventMouseover: (info, e) => {
          const data = merge(info, {
            startFormatted: moment(info.start).format(''),
            startDate: moment(info.start).format('MMM DD'),
            startTime: moment(info.start).format('hh.mma'),
            endDate: moment(info.end).format('MMM DD'),
            endTime: moment(info.end).format('hh.mma'),
            bgcol: info.meta.colors[0]
          })
          tooltipper.setTemplate(tooltipTemplate)
          tooltipper.focus($(e.target).closest('td'), data)
        },
        eventMouseout: (info, e) => {
          tooltipper.focus(false)
        },
        eventRender: (info, e) => {
          e[0].innerHTML = e[0].innerHTML.replace(/!#/g,'')

          e[0].style.backgroundColor = info.meta.colors[0]
          e[0].style.borderColor = info.meta.colors[0]

          if (
            typeof e[0].querySelector('.fc-event-dot') != 'undefined' &&
            e[0].querySelector('.fc-event-dot') != null
          ) {
            e[0].querySelector('.fc-event-dot').style.backgroundColor =
              info.meta.colors[0]
          }
        },
        viewRender: (view, element) => {
          if (view.name === 'month') {
            var currentDate = this.calendar.getDate()
            var year = moment(currentDate, 'YYYY').format('YYYY')
            var currentMonth = moment(currentDate, 'MM').format('MM')

            $('.fc-center').html(
              '<select id="select_month"><option value="">Select Month</option><option value="01">January ' +
                year +
                '</option><option value="02">February ' +
                year +
                '</option><option value="03">March ' +
                year +
                '</option><option value="04">April ' +
                year +
                '</option><option value="05">May ' +
                year +
                '</option><option value="06">June ' +
                year +
                '</option><option value="07">July ' +
                year +
                '</option><option value="08">August ' +
                year +
                '</option><option value="09">September ' +
                year +
                '</option><option value="10">October ' +
                year +
                '</option><option value="11">November ' +
                year +
                '</option><option value="12">December ' +
                year +
                '</option></select>'
            )

            $('#select_month').val(currentMonth)

            $('#select_month').on('change', (e) => {
              currentDate = this.calendar.getDate()
              year = currentDate._i[0]
              var month = e.currentTarget.value
              var newDate = '01/' + month + '/' + year
              // this.calendar.changeView('month', month)
              this.calendar.gotoDate(moment(newDate, 'DD/MM/YYYY'))
            })
          } else {
            $('.fc-center').html('<h2>' + view.title + '</h2>')
          }

          $.ajax({
            type: 'get',
            url: ajax_custom,
            data: {
              action: 'ajax_update_cal_image',
              month: this.calendar.getDate().month(),
              year: this.calendar.getDate().year(),
              features: $('.page-standard').data('features')
            },
            success: function(resp) {
              resp = $.parseJSON(resp)
              console.log(resp)

              if ($('#titleLoader').text() != resp.title) {
                $('#imageLoader').html(resp.image)
                $('#imageLoader img').fadeTo('opacity', 1)
                $('#titleLoader').html(resp.title)
                $('#descLoader').html(resp.descr)
              }
            }
          })
        },
        events: async (start, end, tz, cb) => {
          /* 
            Memo means this function will only be called when 
            start + end hasnt been called before
            */
          const items = await memo(() =>
            Site.callAPI('getCalendarItems', { start, end, tz })
          )(start, end)

          const { years, cats, staffForm } = this.state

          for (var i = 0, len = items.length; i<len; i++) {
            if (items[i].meta.categories.some( category => category === 28 )) {
              items[i].title = '!#' + items[i].title
            }
          };

          const events = items.filter(
            event =>
              intersects(event.meta.categories, cats) &&
              intersects(event.meta.years, years) &&
              (!event.isTeacherEvent ||
                Boolean(event.isTeacherEvent) === Boolean(staffForm.showStaff))
          )

          console.log(events)

          cb(events || [])

          // changed()
        }
      })

      window.cal = this
      window.calendar = this.calendar
      window.moment = moment

      this.setState({ ready: true })
      this.calendar.render()
    },
    react() {
      const update = throttle(() => {
        if (this.calendar) {
          this.calendar.refetchEvents()
          this.calendar.render()
        }
      })
      this.changed('ready', update)
      this.changed('years', update)
      this.changed('cats', update)
      this.changed('events', update)
      this.changed('staffForm', update)

      this.forms.forEach(
        form => setupForm(form, this) && renderForm(form, this)
      )
    },
    resize() {
      window.addEventListener('resize', changed)
    }
  })

  function changed(evt) {
    if (document.documentElement.clientWidth < breakpoints.md.min) {
      this.calendar.changeView('listWeek')
    }
  }

  function setupForm(name, self) {
    const form = self[name]
    const inputs = form.find(`input[data-${name}]`)
    const all = form.find(`[data-all]`)

    const getValues = (allVal = null) => {
      return inputs.get().reduce((formVal, input) => {
        formVal[input.name] = allVal === null ? input.checked : allVal
        return formVal
      }, {})
    }

    self.setState({
      [name]: getValues(name === 'staffForm' ? false : true)
    })

    const onChange = on(inputs, 'change', e => {
      self.setState({ [name]: getValues() })
    })

    if (all.length) {
      const onAllChange = on(all, 'change', e => {
        self.setState({ [name]: getValues(e.target.checked) })
      })
    }

    const onSubmit = on(form, 'submit', e => {
      e.preventDefault()
    })

    return () => {
      onSubmit()
      onChange(), onAllChange()
    }
  }

  function renderForm(name, self) {
    const form = self[name]
    const inputs = form.find(`input[data-${name}]`)
    const generalFields = form.find(`input[data-${name}General]`)
    const all = form.find('[data-all]')
    const filterName = name.replace('Form', '')

    self.changed(name, () => {
      const state = self.state[name]

      /* If there is an all function toggle its vallue if all the values have changed */
      if (all.length) {
        all.get(0).checked = !Object.values(state).some(val => !val)
      }

      inputs
        .toArray()
        .forEach(el =>
          el.type === 'checkbox'
            ? (el.checked = !!state[el.name])
            : (el.value = state[el.name])
        )

      // Hide the general fields but keep state always true
      generalFields
        .toArray()
        .forEach((el) => {
          if (el.type === 'hidden') {
            state[el.name] = true
          }
        })

      /* Turns checked inputs into [checkedInputName] array */
      self.setState({
        [filterName]: Object.entries(state)
          .filter(([name, checked]) => checked)
          .map(([name]) => name)
      })

    })
  }
}

function intersects(arr, arr2) {
  return arr.some(a => {
    for (const b of arr2) {
      if (b == a) {
        return true
      }
    }
  })
}

function wait(t) {
  return new Promise(resolve => setTimeout(resolve, t))
}

/* Cache API is analogous to localStorage */
const cache = {
  cache: {},
  getItem(key) {
    return this.cache[key]
  },
  setItem(key, val) {
    return (this.cache[key] = val)
  },
  hasItem(key) {
    return !!this.cache[key]
  }
}

function memo(fn) {
  return (...args) => {
    const key = args.join(',')
    if (cache.hasItem(key)) {
      return cache.getItem(key)
    }
    return cache.setItem(key, fn(...args))
  }
}

function throttle(func, wait, options) {
  var context, args, result
  var timeout = null
  var previous = 0
  if (!options) options = {}
  var later = function() {
    previous = options.leading === false ? 0 : Date.now()
    timeout = null
    result = func.apply(context, args)
    if (!timeout) context = args = null
  }
  return function() {
    var now = Date.now()
    if (!previous && options.leading === false) previous = now
    var remaining = wait - (now - previous)
    context = this
    args = arguments
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      result = func.apply(context, args)
      if (!timeout) context = args = null
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining)
    }
    return result
  }
}

function merge(...args) {
  return Object.assign({}, ...args)
}
